// extracted by mini-css-extract-plugin
module.exports = {"AiButtonTooltip":"AiButtonTooltip--894cd"};